<template>
    <el-dialog title="公告訊息"
        :visible.sync="dialogVisible" 
        :close-on-press-escape="false" 
        :show-close="false">
        <el-collapse v-model="activeNames">
            <el-collapse-item v-for="(item, index) in dialogData" :key="index" :title="item.title" :name="index">
                <div v-html="item.content"></div>
            </el-collapse-item>
        </el-collapse>
        <div slot="footer" class="dialog-footer">
            <el-button type="success" @click="dialogVisible = false" size="medium">知道了</el-button>
        </div>
    </el-dialog>
  </template>

  <script>
  import _ from 'lodash'

    export default {
        props: {
            show: {
                type: Boolean,
                default: false
            },
            data: {
            },
        },
        data() {
            return {
                dialogData: this.data,
                dialogVisible: this.show,
                activeNames: [0],
            }
        },
        watch: {
            show(newValue) {
                this.dialogVisible = newValue;
            },
            data(newVal) {
                this.dialogData = newVal
            }
        },
        computed: {

        },
        methods: {

        }
    }
  </script>
